
// Get references to all container elements

// Add a click event listener to each container
document.querySelector('.key_ingredient a').addEventListener('click', (event) => {
    console.log('2');
    var targetDiv = container.querySelector('.more_content');

    // Check if the clicked element is the button within the container
    if (event.target === targetButton) {
        // Toggle the visibility of the corresponding div element
        if (targetDiv.style.display === 'none' || targetDiv.style.display === '') {
            targetDiv.style.display = 'block'; // Show the div
        } else {
            targetDiv.style.display = 'none'; // Hide the div
        }
    }
});